import '../modules/flatpickr'
import '../modules/closest'
import 'formdata-polyfill'
import '../modules/forEach'
import '../modules/array-from-polyfill'
import 'element-remove-polyfill'
import 'promise-polyfill/src/polyfill'
import '../modules/flash-messages'
import '../modules/movable-listbox'
import '../modules/text-copy'
import 'cocoon-js'
import './modal'
import menuSlide from './menu-slide'
import FileSizeValidator from '../modules/file-size-validator'

function file_size_validate() {
  const inputElements =  document.querySelectorAll('.m__admin-common__file-upload input[type="file"]')
  inputElements.forEach(inputElement => {
    const maxSize = inputElement.getAttribute('max_size') || 10 // default 10M

    if (maxSize > 0) {
      new FileSizeValidator(inputElement, maxSize).addEventListeners()
    }
  })
}

window.addEventListener('load', () => {
  menuSlide()
  file_size_validate()
})
